import { Button, Grid, TextField, Typography, Box } from "@mui/material";
import React, { useState } from "react";
import { motion } from "framer-motion";
import { ContactSectionBox, ContactSectionHead } from "./style";
import axios from "axios";
import { toast } from "react-toastify";
const DESCO_API_BASE = import.meta.env.VITE_DESCO_API_BASE;

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();
    formDataToSend.append("first_name", formData.name);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("message", formData.message);

    try {
      const res = await axios.post(
        `${DESCO_API_BASE}/contact_us/contact_us`,
        formDataToSend
      );
      toast.success("Submitted successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong!");
    }
  };

  return (
    <ContactSectionBox
      sx={{
        padding: { xs: "0px 30px ", sm: " 80px 80px", lg: " 80px 160px " },
      }}
    >
      <Grid
        container
        // spacing={12}
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "center",
          alignItems: { xs: "center", md: "flex-start" },
        }}
      >
        <Grid item md={6} xs={12}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            style={{
              padding: "30px",
              borderRadius: "16px",
              boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.12)",
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              backdropFilter: "blur(8px)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
            }}
          >
            <form onSubmit={handleSubmit}>
              <TextField
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                required
                sx={{
                  marginBottom: "20px",
                  borderRadius: "12px",
                  background: "#fff",
                  "& .MuiInputLabel-root": {
                    color: "black", // default label color
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#C10E14", // red label on focus
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#e0e0e0",
                    },
                    "&:hover fieldset": {
                      borderColor: "#bdbdbd",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#000",
                    },
                  },
                }}
              />

              <TextField
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                required
                sx={{
                  marginBottom: "20px",
                  borderRadius: "12px",
                  background: "#fff",
                  "& .MuiInputLabel-root": {
                    color: "black", // default label color
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#C10E14", // red label on focus
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#e0e0e0",
                    },
                    "&:hover fieldset": {
                      borderColor: "#bdbdbd",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#000",
                    },
                  },
                }}
              />

              <TextField
                label="Phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                required
                sx={{
                  marginBottom: "20px",
                  borderRadius: "12px",
                  background: "#fff",
                  "& .MuiInputLabel-root": {
                    color: "black", // default label color
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#C10E14", // red label on focus
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#e0e0e0",
                    },
                    "&:hover fieldset": {
                      borderColor: "#bdbdbd",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#000",
                    },
                  },
                }}
              />

              <TextField
                label="Message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                required
                sx={{
                  marginBottom: "25px",
                  borderRadius: "12px",
                  background: "#fff",
                  "& .MuiInputLabel-root": {
                    color: "black", // default label color
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#C10E14", // red label on focus
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#e0e0e0",
                    },
                    "&:hover fieldset": {
                      borderColor: "#bdbdbd",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#000",
                    },
                  },
                }}
              />

              <motion.div
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    padding: "14px",
                    fontWeight: "700",
                    fontSize: "1rem",
                    backgroundColor: "#000",
                    color: "#fff",
                    borderRadius: "12px",
                    textTransform: "none",
                    letterSpacing: "0.5px",
                    "&:hover": {
                      backgroundColor: "#333",
                      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  Send Message
                </Button>
              </motion.div>
            </form>
          </motion.div>
        </Grid>

        <Grid
          item
          md={6}
          xs={12}
          sx={{ paddingTop: { xs: 8, md: 0 }, paddingLeft: { xs: 0, md: 8 } }}
        >
          <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
            <ContactSectionHead>Need Expert Advice?</ContactSectionHead>
          </Box>
          <Typography
            sx={{
              // my: 4,
              textAlign: { xs: "justify", sm: "justify", md: "left" },
              textJustify: "inter-word",
              color: "white",
              fontSize: "16px",
              // marginRight: "10px",
              maxWidth: "60ch",
            }}
          >
            Need Expert Advice? We're Here to Help! Whether you're stepping into
            the real estate market for the first time or you're a seasoned
            investor, expert advice can make all the difference. At Desco, we
            specialize in turning complex real estate decisions into smooth,
            confident moves. Our team of dedicated professionals brings years of
            experience and local expertise to every client we serve. We
            understand the market inside and out, and we're passionate about
            helping you find the best opportunities — whether you're buying,
            selling, or investing.
          </Typography>
        </Grid>
      </Grid>
    </ContactSectionBox>
  );
};

export default ContactSection;
